// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-page-list-___page-list__container___LcThM {
  padding: var(--container-padding);
}

.src-components-page-list-___page-list__list-alert___MhkkE {
  margin-top: 1em;
}

.src-components-page-list-___page-list__page-list___mI64t {
  table-layout: fixed;
}

.src-components-page-list-___page-list__page-list___mI64t > tbody > tr {
  cursor: pointer;
}

.src-components-page-list-___page-list__page-list___mI64t > tbody > tr:hover {
  background-color: var(--gray-lighter);
}

.src-components-page-list-___page-list__page-list___mI64t > tbody > tr > td {
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.src-components-page-list-___page-list__page-list___mI64t > thead > tr > th[data-name="capture-date"] {
  width: 12%;
}

.src-components-page-list-___page-list__page-list___mI64t > thead > tr > th[data-name="site"] {
  width: 15%;
}

.src-components-page-list-___page-list__page-list___mI64t > thead > tr > th[data-name="page-name"] {
  width: 33%;
}

.src-components-page-list-___page-list__page-list___mI64t > thead > tr > th[data-name="url"] {
  width: 40%;
}

.src-components-page-list-___page-list__page-list___mI64t > thead > tr > th[data-name="tags"] {
  width: 30%;
}

.src-components-page-list-___page-list__page-list___mI64t > thead > tr > th[data-name="status"] {
  width: 4.5em;
}

.src-components-page-list-___page-list__page-list___mI64t > thead > tr > th[data-name="active"] {
  width: 4.5em;
}

/* .table styles copied from bootstrap */
.src-components-page-list-___page-list__table___esE4Q {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
}

.src-components-page-list-___page-list__table___esE4Q > thead > tr > th,
.src-components-page-list-___page-list__table___esE4Q > tbody > tr > th,
.src-components-page-list-___page-list__table___esE4Q > tfoot > tr > th,
.src-components-page-list-___page-list__table___esE4Q > thead > tr > td,
.src-components-page-list-___page-list__table___esE4Q > tbody > tr > td,
.src-components-page-list-___page-list__table___esE4Q > tfoot > tr > td {
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}

.src-components-page-list-___page-list__table___esE4Q > thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #ddd;
}

.src-components-page-list-___page-list__table___esE4Q > thead:first-child > tr:first-child > td,
.src-components-page-list-___page-list__table___esE4Q > thead:first-child > tr:first-child > th {
  border-top: 0;
}

.src-components-page-list-___page-list__table___esE4Q th[data-name="domain"] {
  width: 18em;
}

.src-components-page-list-___page-list__page-list___mI64t [data-page-active="false"] {
  opacity: 0.5;
}

.src-components-page-list-___page-list__page-list___mI64t [data-status-category="2xx"] {
  color: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/page-list/page-list.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;;EAME,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".container {\n  padding: var(--container-padding);\n}\n\n.list-alert {\n  margin-top: 1em;\n}\n\n.page-list {\n  table-layout: fixed;\n}\n\n.page-list > tbody > tr {\n  cursor: pointer;\n}\n\n.page-list > tbody > tr:hover {\n  background-color: var(--gray-lighter);\n}\n\n.page-list > tbody > tr > td {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n}\n\n.page-list > thead > tr > th[data-name=\"capture-date\"] {\n  width: 12%;\n}\n\n.page-list > thead > tr > th[data-name=\"site\"] {\n  width: 15%;\n}\n\n.page-list > thead > tr > th[data-name=\"page-name\"] {\n  width: 33%;\n}\n\n.page-list > thead > tr > th[data-name=\"url\"] {\n  width: 40%;\n}\n\n.page-list > thead > tr > th[data-name=\"tags\"] {\n  width: 30%;\n}\n\n.page-list > thead > tr > th[data-name=\"status\"] {\n  width: 4.5em;\n}\n\n.page-list > thead > tr > th[data-name=\"active\"] {\n  width: 4.5em;\n}\n\n/* .table styles copied from bootstrap */\n.table {\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 20px;\n}\n\n.table > thead > tr > th,\n.table > tbody > tr > th,\n.table > tfoot > tr > th,\n.table > thead > tr > td,\n.table > tbody > tr > td,\n.table > tfoot > tr > td {\n  padding: 8px;\n  line-height: 1.42857143;\n  vertical-align: top;\n  border-top: 1px solid #ddd;\n}\n\n.table > thead > tr > th {\n  vertical-align: bottom;\n  border-bottom: 2px solid #ddd;\n}\n\n.table > thead:first-child > tr:first-child > td,\n.table > thead:first-child > tr:first-child > th {\n  border-top: 0;\n}\n\n.table th[data-name=\"domain\"] {\n  width: 18em;\n}\n\n.page-list [data-page-active=\"false\"] {\n  opacity: 0.5;\n}\n\n.page-list [data-status-category=\"2xx\"] {\n  color: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `src-components-page-list-___page-list__container___LcThM`,
	"list-alert": `src-components-page-list-___page-list__list-alert___MhkkE`,
	"listAlert": `src-components-page-list-___page-list__list-alert___MhkkE`,
	"page-list": `src-components-page-list-___page-list__page-list___mI64t`,
	"pageList": `src-components-page-list-___page-list__page-list___mI64t`,
	"table": `src-components-page-list-___page-list__table___esE4Q`
};
export default ___CSS_LOADER_EXPORT___;
